
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexydUFB0gtMQHiPlWSit7ZkebUI0UCM1tvQaM6Z_45RK6gAMeta } from "/tmp/tmpkxhg0ioy/pages/index.vue?macro=true";
import { default as indexXVugOdOmYzVj69X93BpEpHY_45Z4mTyyhociRJA7vrvfUMeta } from "/tmp/tmpkxhg0ioy/pages/[area]/index.vue?macro=true";
import { default as index9rR2XfP4WCpcMPe7LYM4VbU9t8KcdoJPDrrD57DbvOoMeta } from "/tmp/tmpkxhg0ioy/pages/okinawa/index.vue?macro=true";
import { default as indexRtBl7bG2jzFwcQ5TN2Bl_pri9Lb4hfrwNWknqSZpwssMeta } from "/tmp/tmpkxhg0ioy/pages/zoom-map/index.vue?macro=true";
import { default as indexz7N0YRxy4h1fT4gTJplnfUwCVBNp9UjV46JZzjNXtxgMeta } from "/tmp/tmpkxhg0ioy/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexzwJISKILM4_0arm3iTrmMNKRMdvLiSc5EgTntRcNcXsMeta } from "/tmp/tmpkxhg0ioy/pages/[area]/[pref]/index.vue?macro=true";
import { default as index8f_yfsvo0jelQCMjEHhNK7RWT5VKyS_45SENyL5oif__45UMeta } from "/tmp/tmpkxhg0ioy/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpkxhg0ioy/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpkxhg0ioy/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpkxhg0ioy/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmpkxhg0ioy/pages/zoom-map/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpkxhg0ioy/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpkxhg0ioy/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpkxhg0ioy/pages/[area]/[pref]/[id]/index.vue")
  }
]